const get = require('lodash/get')
const reduce = require('lodash/reduce')
const cloneDeep = require('lodash/cloneDeep')
const queryString = require('query-string')
const dateFns = require('date-fns')
const getTime = require('date-fns/get_time')
const differenceInSeconds = require('date-fns/difference_in_seconds')
const UAParser= require('ua-parser-js')
const cookie = require('./utils/cookie.js')

const parsedUserAgentInstance = new UAParser()

function reduceCompose(a, b) {
  return function (...args) {
    return a(b(...args))
  }
}

function compose(funcs) {
  return reduce(funcs, reduceCompose)
}

const globalProperties = {
  has_adblock: false,
}

function updateGlobalProperties(key, value) {
  globalProperties[key] = value
}

function isAdBlockDetected() {
  if (!window) return false
  if (typeof window.blockAdBlock === 'undefined') {
    return updateGlobalProperties('has_adblock', true)
  }
  window.blockAdBlock.onDetected(() => {
    return updateGlobalProperties('has_adblock', true)
  })
  window.blockAdBlock.onNotDetected(() => {
    return updateGlobalProperties('has_adblock', false)
  })
}

function attachUTMParams(properties) {
  const parsedQueryParams = queryString.parse(get(window, 'location.search'))
  const utm_campaign = get(parsedQueryParams, 'utm_campaign', null)
  const utm_content = get(parsedQueryParams, 'utm_content', null)
  const utm_medium = get(parsedQueryParams, 'utm_medium', null)
  const utm_source = get(parsedQueryParams, 'utm_source', null)
  const utm_term = get(parsedQueryParams, 'utm_term', null)
  const utm_id = get(parsedQueryParams, 'utm_id', null)

  return {
    ...properties,
    utm_campaign,
    utm_content,
    utm_medium,
    utm_source,
    utm_term,
    utm_id,
  }
}

function attachUserInformation(properties) {
  const accountUuid =
    get(window, 'BOOTSTRAP_DATA.authentication.user.uuid', null)
  const latestTriggerTime = localStorage.getItem('latest-trigger-time')
  const shopbackSessionIdKey = localStorage.getItem('shopback-session-time-key')
  const currentTimestamp = getTime(new Date())
  const latestTriggerTimeDiff = differenceInSeconds(
    new Date(),
    new Date(parseInt(latestTriggerTime, 10)),
  )
  const FIVE_MINUTES_IN_SECONDS = 60 * 5
  const locale = cookie.read('locale') || null
  let shopback_session_id = null

  if (!latestTriggerTime || latestTriggerTimeDiff > FIVE_MINUTES_IN_SECONDS) {
    localStorage.setItem('latest-trigger-time', currentTimestamp)
    localStorage.setItem('shopback-session-time-key', currentTimestamp)
    shopback_session_id = `${accountUuid || 'guest'}_${currentTimestamp}`
  } else {
    shopback_session_id = `${accountUuid || 'guest'}_${shopbackSessionIdKey}`
  }

  return {
    ...properties,
    shopback_session_id,
    accountUuid,
    locale,
    display_locale: locale,
    is_logged_in: !!accountUuid,
  }
}

const specialScreenTypeMap = {
  campaign_v2: 'campaign',
}

function attachPageInformation(properties) {
  const domain = get(window, 'BOOTSTRAP_DATA.domain', '')
  const screen_url = get(window, 'location.href', '')
  const layout_id = get(window, 'BOOTSTRAP_DATA.layout_id', '')
  const layout_name = get(window, 'BOOTSTRAP_DATA.layout_name', '')
  const tracking_data = get(window, 'BOOTSTRAP_DATA.tracking_data', '')
  const referrer = get(window, 'document.referrer', '')

  return {
    ...properties,
    ...tracking_data,
    domain,
    screen_url,
    layout_id,
    layout_name,
    is_first_entry: !referrer
  }
}

function attachTimestamp(properties) {
  return {
    ...properties,
    timestamp: dateFns.format(new Date(), 'X'),
  }
}

function attachDetectExtension(properties) {
  // SbExtensionAwesomeCheck is set by Shopback Buddy Extension
  const has_extension = !!get(window, 'SbExtensionAwesomeCheck', false)

  return {
    ...properties,
    has_extension,
  }
}

function attachBrowserAndDeviceInfo(properties) {
  const parsedUaResult = parsedUserAgentInstance.getResult()
  const isMobile = get(window, 'BOOTSTRAP_DATA.is_mobile', false)
  const browser = parsedUaResult.browser || {
    name: null,
    version: null
  }
  const device = parsedUaResult.device || {
    model: null,
    vendor: null
  }
  const screen = window.screen || {
    availWidth: 0,
    availHeight: 0,
  }
  const devicePixelRatio = window.devicePixelRatio || 0
  return {
    ...properties,
    screen_resolution: `${screen.availWidth * devicePixelRatio} x ${screen.availHeight * devicePixelRatio}`,
    user_agent: get(window, 'navigator.userAgent', null),
    web_platform: isMobile ? 'mobile_web' : 'desktop_web',
    browser_name: browser.name,
    browser_version: `${browser.name}_${browser.version}`,
    device_type: `${device.vendor} ${device.model}`
  }
}

function attachReferrerInformation(properties) {
  const previous_screen_url = get(window, 'document.referrer', '')

  return {
    ...properties,
    previous_screen_url,
  }
}

const propertiesHandler = [
  attachUTMParams,
  attachUserInformation,
  attachBrowserAndDeviceInfo,
  attachPageInformation,
  attachTimestamp,
  attachDetectExtension,
  attachReferrerInformation,
]

const mainHandler = compose(propertiesHandler)

function getProperties() {
  const defaultProperties = cloneDeep(globalProperties)
  const properties = mainHandler(defaultProperties)
  return properties
}

isAdBlockDetected()

module.exports = getProperties
